import React from "react";
import { Row, Col, Typography, Button, Input, Switch, Spin, Card } from "antd";

import EditCards from "./EditCards";
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;

const LiveStream = ({
  streamLoading,
  liveStreamUrl,
  liveStreamTitle,
  setLiveStreamUrl,
  setliveStreamTitle,
  isLiveStream,
  toggleLiveStream,
  tokenLoading,
  notificationTitle,
  setNotificationTitle,
  notificationMessage,
  setNotificationMessage,
  sendPushNotification,
  articleSliders,
  loading,
  removeArticleSlider,
  addArticleSlider,
  newsSliders,
  removeNewsSlider,
  addNewsSlider,
}) => {
  return (
    <Card style={{ marginLeft: 5, height: "100%", borderRadius: "15px" }}>
      <Title level={3}>Live Stream</Title>
      <Spin spinning={streamLoading}>
        <Row>
          <Col flex={0.1}>
            <Paragraph>Stream Url:</Paragraph>
          </Col>
          <Col flex={1}>
            <Input
              placeholder="Enter live stream url"
              value={liveStreamUrl}
              onChange={({ target }) => setLiveStreamUrl(target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col flex={0.1}>
            <Paragraph>Stream Title:</Paragraph>
          </Col>
          <Col flex={1}>
            <Input
              placeholder="Enter title"
              value={liveStreamTitle}
              onChange={({ target }) => setliveStreamTitle(target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col flex={0.1}>
            <Paragraph>Switch LiveStream:</Paragraph>
          </Col>
          <Col flex={1}>
            <Switch
              checked={isLiveStream}
              onChange={(checked) => toggleLiveStream(checked)}
            />
          </Col>
        </Row>
      </Spin>
      <Row>
        <Spin spinning={tokenLoading}>
          <Title level={4}>Send Push Notification</Title>
          <Input
            placeholder="Enter Notification Title"
            style={{ marginTop: 5, width: "80%" }}
            value={notificationTitle}
            onChange={({ target }) => setNotificationTitle(target.value)}
          />
          <Input
            placeholder="Enter Notification Message"
            style={{ marginTop: 5, width: "80%" }}
            value={notificationMessage}
            onChange={({ target }) => setNotificationMessage(target.value)}
          />
          <Button
            onClick={sendPushNotification}
            type="primary"
            style={{ marginTop: 5 }}
          >
            Send Message
          </Button>
        </Spin>
      </Row>
      <Row>
        <Title style={{ marginTop: 15 }} level={4}>
          1st Tab Sliders
        </Title>
        <EditCards
          deck={articleSliders}
          loading={loading}
          onRemoveCardClick={removeArticleSlider}
          onFileUpload={addArticleSlider}
        />
      </Row>
      <Row>
        <Title level={4}>2nd Tab Sliders</Title>
        <EditCards
          deck={newsSliders}
          loading={loading}
          onRemoveCardClick={removeNewsSlider}
          onFileUpload={addNewsSlider}
        />
      </Row>
      <Row>
        <Title level={4}>How to Show Social Feeds: </Title>
      </Row>
      <Row>
        <Col flex={0.1}>
          1. Go to below link
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          2. Paste the src link
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          3. Generate the embed code
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          4. Paste into Editor
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          <Paragraph style={{ marginTop: 25, fontSize: 20 }}>Twitter: <a href="https://publish.twitter.com/" >Twitter link to generate embedded code</a> </Paragraph>  
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          <Paragraph style={{ marginTop: 0, fontSize: 20 }}>Spotify: <a href="https://developer.spotify.com/documentation/widgets/generate/embed/" >Spotify link to generate embedded code</a></Paragraph>
        </Col>
      </Row>
      <Row>
        <Col flex={0.1}>
          <Paragraph style={{ marginTop: 0, fontSize: 20 }}>Instagram: Use this below code and replace url from below href tag with your "Instagram Post" link 
        and paste it to editor</Paragraph>
        </Col>
        <Col flex={1}>
            <div>{'<blockquote class="instagram-media"><a href="https://www.instagram.com/p/COBMBL3Df_T/?utm_source=ig_web_copy_link"></a></blockquote><script async defer src="https://platform.instagram.com/en_US/embeds.js"></script>'}</div>
        />
        </Col>
      </Row>
    </Card>
  );
};

export default LiveStream;
